import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  orderPageLoading: false,
  loading: false,
  error: null,
  orders: null,
  fetchingDropdown: false,
  dropdowns: {},
  fetchingLabs: false,
  labs: null,
  fetchingLogisticPartners: false,
  logisticPartners: null,
  labsUnderUpdate: {},
  samplerUnderUpdate: {},
  logisticsUnderUpdate: {},
  statusUnderUpdate: {},
  orderUnderUpdate: {},
  downloadInProgress: {},
  reportUploadInProgress: {},
  poUploadInProgress: {},
  addOrderInProgress: false,
  pendingReport: [],
  orderCount: 0,
  fetchingCompanies: false,
  companies: [],
  raiseServiceRequest: false,
  companyUsers: null,
  commodities: [],
  fetchingCommodities: false,
  states: [],
  fetchingStates: false,
  districts: [],
  fetchingDistricts: false,
  samplers: [],
  fetchingSamplers: false,
  projectCodesForAddOrder: [],
  projectCodesForFilter: [],
  fetchingProjectCodes: false,
  filters: {},
  sectors: [],
  projectData: {},
  agencies: [],
  
  // ✨ NEW: Package state
  packages: [],
  fetchingPackages: false,
  packagesError: null,
};

const orderListingSlice = createSlice({
  name: "orderListing",
  initialState,
  reducers: {
    fetchOrders(state, action) {
      state.orderPageLoading = true;
    },
    fetchOrdersSuccess(state, action) {
      state.orders = action.payload.data.document;
      state.orderCount = action.payload.data.paginationMetadata.total;
      state.orderPageLoading = false;
    },
    fetchOrdersFailure(state, action) {
      state.orderPageLoading = false;
    },
    fetchPendingOrderReport(state, action) {
      state.loading = true;
    },
    fetchPendingOrderReportSuccess(state, action) {
      state.pendingReport = action.payload.data.document;
      state.loading = false;
    },
    fetchPendingOrderReportFailure(state, action) {
      state.loading = false;
    },
    fetchDropdown(state, action) {
      state.fetchingDropdown = true;
    },
    fetchDropdownSuccess(state, action) {
      state.fetchingDropdown = false;
      state.dropdowns = action.payload.data.document;
    },
    fetchDropdownFailure(state, action) {
      state.fetchingDropdown = false;
    },
    fetchLabs(state, action) {
      state.fetchingLabs = true;
    },
    fetchLabsSuccess(state, action) {
      state.labs = action.payload.data.document;
      state.fetchingLabs = false;
    },
    fetchLabsFailure(state, action) {
      state.fetchingLabs = false;
    },
    fetchCompanies(state, action) {
      state.fetchingCompanies = true;
    },
    fetchCompaniesSuccess(state, action) {
      state.companies = action.payload.data.document;
      state.fetchingCompanies = false;
    },
    fetchCompaniesFailure(state, action) {
      state.fetchingCompanies = false;
    },
    fetchCompanyUsers(state, action) {
      state.loading = true;
    },
    fetchCompanyUsersSuccess(state, action) {
      state.companyUsers = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyUsersFailure(state, action) {
      state.loading = false;
    },
    fetchLogisticPartners(state, action) {
      state.fetchingLogisticPartners = true;
    },
    fetchLogisticPartnersSuccess(state, action) {
      state.logisticPartners = action.payload.data.document;
      state.fetchingLogisticPartners = false;
    },
    fetchLogisticPartnersFailure(state, action) {
      state.fetchingLogisticPartners = false;
    },
    updateLab(state, action) {
      state.labsUnderUpdate[action.payload.id] = true;
    },
    updateLabSuccess(state, action) {
      state.labsUnderUpdate[action.payload.id] = false;
    },
    updateLabFailure(state, action) {
      state.labsUnderUpdate[action.payload.id] = false;
    },
    updateSampler(state, action) {
      state.samplerUnderUpdate[action.payload.id] = true;
    },
    updateSamplerSuccess(state, action) {
      state.samplerUnderUpdate[action.payload.id] = false;
    },
    updateSamplerFailure(state, action) {
      state.samplerUnderUpdate[action.payload.id] = false;
    },
    updateLogistics(state, action) {
      state.logisticsUnderUpdate[action.payload.id] = true;
    },
    updateLogisticsSuccess(state, action) {
      const index = state.orders.findIndex(
        (order) => order._id === action.payload.data.document._id
      );
      if (index !== -1) state.orders[index] = action.payload.data.document;
      state.logisticsUnderUpdate[action.payload.data.document._id] = false;
    },
    updateLogisticsFailure(state, action) {
      state.logisticsUnderUpdate[action.payload.id] = false;
    },
    updateOrderStatus(state, action) {
      state.statusUnderUpdate[action.payload.id] = true;
    },
    updateOrderStatusSuccess(state, action) {
      const index = state.orders.findIndex(
        (order) => order._id === action.payload.data.document._id
      );
      if (index !== -1) state.orders[index] = action.payload.data.document;
      state.statusUnderUpdate[action.payload.data.document._id] = false;
    },
    updateOrderStatusFailure(state, action) {
      state.statusUnderUpdate[action.payload.id] = false;
      state.error = action.payload.error;
    },
    downloadPurchaseOrder(state, action) {
      state.downloadInProgress[action.payload.id] = true;
    },
    downloadPurchaseOrderSuccess(state, action) {
      const index = state.orders.findIndex(
        (order) => order._id === action.payload.data.document._id
      );
      if (index !== -1) state.orders[index] = action.payload.data.document;
      state.downloadInProgress[action.payload.id] = false;
    },
    downloadPurchaseOrderFailure(state, action) {
      state.downloadInProgress[action.payload.id] = false;
      state.error = action.payload.error;
    },
    uploadReport(state, action) {
      state.reportUploadInProgress[action.payload.id] = true;
    },
    uploadReportSuccess(state, action) {
      const index = state.orders.findIndex(
        (order) => order._id === action.payload.data.document._id
      );
      if (index !== -1) state.orders[index] = action.payload.data.document;
      state.reportUploadInProgress[action.payload.id] = false;
    },
    uploadReportFailure(state, action) {
      state.reportUploadInProgress[action.payload.id] = false;
      state.error = action.payload.message;
    },
    uploadPurchaseOrder(state, action) {
      state.poUploadInProgress[action.payload.id] = true;
    },
    uploadPurchaseOrderSuccess(state, action) {
      const index = state.orders.findIndex(
        (order) => order._id === action.payload.data.document._id
      );
      if (index !== -1) state.orders[index] = action.payload.data.document;
      state.poUploadInProgress[action.payload.id] = false;
    },
    uploadPurchaseOrderFailure(state, action) {
      state.poUploadInProgress[action.payload.id] = false;
      state.error = action.payload.error;
    },
    updateOrder(state, action) {
      state.orderUnderUpdate[action.payload.id] = true;
    },
    updateOrderSuccess(state, action) {
      const index = state.orders.findIndex(
        (order) => order._id === action.payload.data.document._id
      );
      if (index !== -1) state.orders[index] = action.payload.data.document;
      state.orderUnderUpdate[action.payload.data.document._id] = false;
    },
    updateOrderFailure(state, action) {
      state.orderUnderUpdate[action.payload.id] = false;
      state.error = action.payload.error;
    },
    serviceRequest(state, action) {
      state.raiseServiceRequest = true;
    },
    serviceRequestSuccess(state, action) {
      state.raiseServiceRequest = false;
    },
    serviceRequestFailure(state, action) {
      state.raiseServiceRequest = false;
      state.error = action.payload.error;
    },
    initializeError(state, action) {
      state.error = null;
    },
    addOrder(state, action) {
      state.addOrderInProgress = true;
    },
    addOrderSuccess(state, action) {
      state.addOrderInProgress = false;
    },
    addOrderFailure(state, action) {
      state.addOrderInProgress = false;
      state.error = action.payload.error;
    },
    fetchCommodities(state, action) {
      state.fetchingCommodities = true;
    },
    fetchCommoditiesSuccess(state, action) {
      state.fetchingCommodities = false;
      state.commodities = action.payload.data.document;
    },
    fetchCommoditiesFailure(state, action) {
      state.fetchingCommodities = false;
    },
    fetchStates(state, action) {
      state.fetchingStates = true;
    },
    fetchStatesSuccess(state, action) {
      state.fetchingStates = false;
      state.states = action.payload.data.document;
    },
    fetchStatesFailure(state, action) {
      state.fetchingStates = false;
    },
    fetchDistricts(state, action) {
      state.fetchingDistricts = true;
      state.districts = [];
    },
    fetchDistrictsSuccess(state, action) {
      state.fetchingDistricts = false;
      state.districts = action.payload.data.districts;
    },
    fetchDistrictsFailure(state, action) {
      state.fetchingDistricts = false;
    },
    fetchSamplers(state, action) {
      state.fetchingSamplers = true;
      state.samplers = [];
    },
    fetchSamplersSuccess(state, action) {
      state.fetchingSamplers = false;
      state.samplers = action.payload.data.sampler;
    },
    fetchSamplersFailure(state, action) {
      state.fetchingSamplers = false;
    },
    fetchProjectCodes(state, action) {
      state.fetchingProjectCodes = true;
      if (action.payload.for === "AddOrder") {
        state.projectCodesForAddOrder = [];
      } else if (action.payload.for === "filter") {
        state.projectCodesForFilter = [];
      }
    },
    fetchProjectCodesSuccess(state, action) {
      state.fetchingProjectCodes = false;
      if (action.payload.for === "filter") {
        state.projectCodesForFilter = action.payload.data.data;
      } else if (action.payload.for === "AddOrder") {
        state.projectCodesForAddOrder = action.payload.data.data;
      }
    },
    fetchProjectCodesFailure(state, action) {
      state.fetchingProjectCodes = false;
    },
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.states = [];
      state.commodities = [];
      state.districts = [];
      state.samplers = [];
    },

    bulkLabAssignment(state, action) {},
    bulkLabAssignmentSuccess(state, action) {},
    bulkLabAssignmentFailure(state, action) {},

    bulkChangeOrderStatus(state, action) {},
    bulkChangeOrderStatusSuccess(state, action) {},
    bulkChangeOrderStatusFailure(state, action) {},

    logisticsAssignment(state, action) {},
    logisticsAssignmentSuccess(state, action) {},
    logisticsAssignmentFailure(state, action) {},

    bulkSamplerAssignment(state, action) {},
    bulkSamplerAssignmentSuccess(state, action) {},
    bulkSamplerAssignmentFailure(state, action) {},

    setFilters(state, action) {
      state.filters = action.payload;
    },
    clearProjectCodesForFilter(state, action) {
      state.projectCodesForFilter = [];
    },

    fetchSectors: (state, action) => {},
    fetchSectorsSuccess: (state, action) => {
      state.sectors = action.payload.data?.document;
    },
    fetchSectorsFailure: (state, action) => {},

    fetchPackages: (state, action) => {
      state.fetchingPackages = true;
      state.packagesError = null;
    },
    fetchPackagesSuccess: (state, action) => {
      state.fetchingPackages = false;
      state.packages =
        action.payload.data?.document || action.payload.data?.data || [];
      state.packagesError = null;
    },
    fetchPackagesFailure: (state, action) => {
      state.fetchingPackages = false;
      state.packagesError = action.payload?.message;
    },
    clearPackages: (state) => {
      state.packages = [];
      state.packagesError = null;
    },

    fetchProjectConfig: (state, action) => {
      state.projectData = {};
    },
    fetchProjectConfigSuccess: (state, action) => {
      state.projectData =
        action.payload.data;
    },
    fetchProjectConfigFailure: (state, action) => {},

    fetchAgencies: (state, action) => {},
    fetchAgenciesSuccess: (state, action) => {
      state.agencies = action.payload.data?.documents || [];
    },
    fetchAgenciesFailure: (state, action) => {},
  },
});

export const { actions, reducer, name: sliceKey } = orderListingSlice;